import type { PropsWithChildren } from "react";

import { ImageBackground } from "react-native";

import { joinTestIDs } from "@/utils/string.util";

const FullScreenImageBackground = ({
  children,
  testID,
}: PropsWithChildren<ViewWithTestID>) => {
  return (
    <ImageBackground
      resizeMode="cover"
      source={require("@/assets/images/main-background.png")}
      style={{ height: "100%", width: "100%" }}
      testID={joinTestIDs(testID, "background")}
    >
      {children}
    </ImageBackground>
  );
};

export default FullScreenImageBackground;
